import { GET_CUSTOMIZE_ORDER, GET_CUSTOMIZE_ORDER_ERROR, GET_CUSTOMIZE_ORDER_SUCCESS, UPDATE_CUSTOMIZE_ORDER, UPDATE_CUSTOMIZE_ORDER_ERROR, UPDATE_CUSTOMIZE_ORDER_SUCCESS } from "./actionTypes"

export const getCustomizeOrder = (page_name) => {
    return (
        {
            type: GET_CUSTOMIZE_ORDER,
            payload: page_name
        }
    )
}

export const getCustomizeOrderSuccess = (columns_order) => {
    return (
        {
            type: GET_CUSTOMIZE_ORDER_SUCCESS,
            payload: columns_order
        }
    )
}

export const getCustomizeOrderError = (error) => {
    return (
        {
            type: GET_CUSTOMIZE_ORDER_ERROR,
            payload: error
        }
    )
}


export const updateCustomizeOrder = (columns_order) => {
    return (
        {
            type: UPDATE_CUSTOMIZE_ORDER,
            payload: columns_order
        }
    )
}

export const updateCustomizeOrderSuccess = (columns_order, component) => {
    return (
        {
            type: UPDATE_CUSTOMIZE_ORDER_SUCCESS,
            payload: columns_order,
            component: component
        }
    )
}

export const updateCustomizeOrderError = (error) => {
    return (
        {
            type: UPDATE_CUSTOMIZE_ORDER_ERROR,
            payload: error
        }
    )

}